import { memo, useCallback, useEffect, useRef } from 'react';
import AnimateTop from 'components/AnimateTop';
import StepLayout from 'components/layout/StepLayout';
import Footer from 'components/footer/Footer';
import { FooterOkBtn, FooterPressText } from 'components/footer/Footer.styled';
import { HiOutlineCheck } from 'react-icons/hi';
import BaseInput from 'components/common/BaseInput';
import { Step5Content } from './Step5.styled';
import { Formik, Form } from 'formik';
import { VALIDATION_STEP_5 } from 'utils/validations';
import { useSelector, useDispatch } from 'react-redux';
import { fillStep5Data, sendContactInfo } from 'store/slices/form.slice';
import { nextStep, prevStep } from 'store/slices/global.slice';
import BaseSpinner from 'components/common/BaseSpinner';

const Step5 = () => {
  const { address, loading } = useSelector((state) => state.form);
  const dispatch = useDispatch();
  const altStreetRef = useRef(null);

  const onSubmitStep5 = useCallback(
    async (values) => {
      await dispatch(fillStep5Data({ altStreet: values.altStreet }));
      await dispatch(sendContactInfo());
      await dispatch(nextStep());
    },
    [dispatch]
  );

  useEffect(() => {
    if (altStreetRef.current) altStreetRef.current.focus();
  }, [altStreetRef]);

  return (
    <AnimateTop>
      {!loading ? (
        <>
          <StepLayout title='If the address includes an apartment, suite, etc, please enter it below?'>
            <Formik
              initialValues={{
                altStreet: address.streetByClient,
              }}
              validationSchema={VALIDATION_STEP_5}
              onSubmit={onSubmitStep5}
            >
              <Form>
                <Step5Content>
                  <BaseInput
                    name='altStreet'
                    placeholder='Apartment, Suite, etc'
                    ref={altStreetRef}
                  />
                </Step5Content>
                <Footer prevArrowClick={() => dispatch(prevStep())}>
                  <FooterOkBtn type='submit'>
                    OK <HiOutlineCheck />
                  </FooterOkBtn>
                  <FooterPressText>press Enter ↵</FooterPressText>
                </Footer>
              </Form>
            </Formik>
          </StepLayout>
        </>
      ) : (
        <>
          <BaseSpinner />
        </>
      )}
    </AnimateTop>
  );
};

export default memo(Step5);
